<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">
                {{ poi.id ? $t('poi.form.editTitle') : $t('poi.form.newTitle') }}
              </div>
            </div>
            <hr style="margin-top: -4px" />
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-row">
                    <div class="form-group col-md-12">
                      <label>
                        <span class="required">*</span> {{ $t('poi.form.searchAddressLabel') }}
                      </label>
                      <GmapAutocomplete
                        ref="autocomplete"
                        class="form-control"
                        :placeholder="$t('poi.form.searchAddressPlaceholder')"
                        @place_changed="onPlaceChanged"
                      />
                    </div>
                  </div>

                  <div class="form-row">
                    <div class="col-md-12 mb-3">
                      <GmapMap
                        ref="mapRef"
                        :center="mapCenter"
                        :zoom="mapZoom"
                        map-type-id="roadmap"
                        style="width: 100%; height: 300px"
                        @click="onMapClick"
                      >
                        <GmapMarker
                          v-if="poi.latitude && poi.longitude"
                          :position="{
                            lat: parseFloat(poi.latitude),
                            lng: parseFloat(poi.longitude),
                          }"
                          :draggable="true"
                          @dragend="onMarkerDrag"
                        />
                      </GmapMap>
                      <small class="text-muted">{{ $t('poi.form.mapHint') }}</small>
                    </div>
                  </div>

                  <div class="form-row">
                    <div class="form-group col-md-6">
                      <label>
                        <span class="required">*</span> {{ $t('poi.form.typeLabel') }}
                      </label>
                      <v-select
                        :options="poiTypes"
                        :reduce="(poiTypes) => poiTypes.id"
                        :label="'name'"
                        v-model="poi.poi_type_id"
                        v-on:input="onPoiTypeChange"
                        class="vselect"
                      />
                    </div>
                    <div class="form-group col-md-6">
                      <label>
                        <span class="required">*</span> {{ $t('poi.form.nameLabel') }}
                      </label>
                      <input
                        autocomplete="new-password"
                        type="text"
                        class="form-control"
                        v-model="poi.name"
                        placeholder=""
                      />
                    </div>
                  </div>

                  <div class="form-row">
                    <div class="form-group col-md-6">
                      <label>
                        <span class="required">*</span> {{ $t('common.status') }}
                      </label>
                      <select v-model="poi.status" class="form-control">
                        <option :value="1">{{ $t('common.active') }}</option>
                        <option :value="0">{{ $t('common.inactive') }}</option>
                      </select>
                    </div>
                  </div>

                  <!-- Campos dinâmicos do Tipo de Ponto de Interesse -->
                  <div v-if="fieldSchema.length" class="poi-specific-card mt-2">
                    <div class="poi-specific-card__header">
                      <feather-icon icon="SlidersIcon" size="15" class="mr-50" />
                      <span>{{ $t('poi.form.specificInfoTitle') }}</span>
                    </div>
                    <div class="poi-specific-card__body">
                      <div class="form-row">
                        <div
                          v-for="field in fieldSchema"
                          :key="field.key"
                          :class="['form-group', field.col || 'col-md-6']"
                        >
                          <label class="poi-specific-card__label">
                            <span v-if="field.required" class="required">*</span>
                            {{ field.label }}
                          </label>
                          <input
                            v-if="field.type === 'text'"
                            v-model="poi.metadata[field.key]"
                            class="form-control"
                            type="text"
                          />
                          <input
                            v-else-if="field.type === 'number'"
                            v-model="poi.metadata[field.key]"
                            class="form-control"
                            type="number"
                          />
                          <textarea
                            v-else-if="field.type === 'textarea'"
                            v-model="poi.metadata[field.key]"
                            class="form-control"
                            rows="3"
                          />
                          <select
                            v-else-if="field.type === 'select'"
                            v-model="poi.metadata[field.key]"
                            class="form-control"
                          >
                            <option value="">{{ $t('common.select') }}</option>
                            <option v-for="opt in field.options" :key="opt" :value="opt">
                              {{ opt }}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>

                  <span class="required_fields">
                    <span class="required">*</span>
                    <strong>{{ $t('poi.form.requiredFieldsNote') }}</strong>
                  </span>
                  <div class="block text-right">
                    <router-link to="/pois" class="btn btn-back mr-1">
                      <i class="fa fa-arrow-left"></i> {{ $t('common.back') }}
                    </router-link>
                    <a v-if="$hasAbility('cadastro.gerenciar')" class="btn btn-add" @click="save">
                      {{ $t('common.save') }}
                      <i class="fa fa-save"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";
import Loading from "vue-loading-overlay";

export default {
  data() {
    return {
      poi: {
        name: "",
        poi_type_id: null,
        latitude: null,
        longitude: null,
        metadata: {},
        status: 1,
      },
      poiTypes: [],
      fieldSchema: [],
      mapCenter: { lat: -15.77972, lng: -47.92972 },
      mapZoom: 13,
    };
  },
  computed: {},
  methods: {
    onPlaceChanged(place) {
      if (!place || !place.geometry) return;

      const loc = place.geometry.location;
      this.poi.latitude = loc.lat();
      this.poi.longitude = loc.lng();
      this.mapCenter = { lat: loc.lat(), lng: loc.lng() };
      this.mapZoom = 17;
    },

    onMapClick(event) {
      const lat = event.latLng.lat();
      const lng = event.latLng.lng();
      this.poi.latitude = lat;
      this.poi.longitude = lng;

      if (window.google && window.google.maps) {
        const geocoder = new window.google.maps.Geocoder();
        geocoder.geocode({ location: { lat, lng } }, (results, status) => {
          if (status === "OK" && results[0]) {
            const place = results[0];
            const input = this.$refs.autocomplete;
            if (input && input.$refs && input.$refs.input) {
              input.$refs.input.value = place.formatted_address;
            }
          }
        });
      }
    },

    onMarkerDrag(event) {
      this.poi.latitude = event.latLng.lat();
      this.poi.longitude = event.latLng.lng();
    },

    onPoiTypeChange: function (typeId) {
      const type = this.poiTypes.find((t) => t.id === typeId);
      this.fieldSchema = type && type.field_schema ? type.field_schema : [];

      const meta = this.poi.metadata || {};
      this.fieldSchema.forEach((f) => {
        if (!(f.key in meta)) meta[f.key] = "";
      });
      this.poi.metadata = meta;
    },

    save: function () {
      const self = this;
      let api = self.$store.state.api + "pois";

      if (self.poi.id) {
        self.poi._method = "PUT";
        api += "/" + self.poi.id;
      }

      self.$loading(true);

      axios
        .post(api, self.poi)
        .then(() => {
          self.$message(
            self.$t("poi.messages.saveSuccessTitle"),
            self.$t("poi.messages.saveSuccessMessage"),
            "success"
          );
          self.$loading(false);
          this.$router.push("/pois");
        })
        .catch((error) => {
          self.$loading(false);
          self.$message(null, error.response.data, "error");
        });
    },
    getPoiTypes: function () {
      const self = this;
      let api = self.$store.state.api + "poi_types?paginated=false&status=1";

      return axios
        .get(api)
        .then((response) => {
          self.poiTypes = response.data.data;
          if (self.poi.poi_type_id) {
            self.onPoiTypeChange(self.poi.poi_type_id);
          }
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getPoi: function (id) {
      const self = this;
      const api = self.$store.state.api + "pois/" + id;
      self.$loading(true);

      axios
        .get(api)
        .then((response) => {
          const data = response.data.data[0];
          if (!data.metadata) data.metadata = {};
          self.poi = data;
          if (self.poi.latitude && self.poi.longitude) {
            self.mapCenter = {
              lat: parseFloat(self.poi.latitude),
              lng: parseFloat(self.poi.longitude),
            };
          }
          if (self.poiTypes.length && self.poi.poi_type_id) {
            self.onPoiTypeChange(self.poi.poi_type_id);
          }
          self.$loading(false);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted: function () {
    const self = this;

    self.getPoiTypes();

    let id = self.$route.params.id;
    if (id) {
      self.getPoi(id);
    }
  },
  components: {
    BaseCrud,
    vSelect,
    Loading,
  },
};
</script>
<style scoped>
.custom-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 255, 128, 0);
  backdrop-filter: blur(3px);
  opacity: 0.98;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
.custom-loading-spinner {
  width: 100px;
  height: 100px;
  z-index: 10000;
}

.poi-specific-card {
  background: #f8f8fb;
  border: 1px solid #ebe9f1;
  border-radius: 6px;
  overflow: hidden;
}

.poi-specific-card__header {
  display: flex;
  align-items: center;
  padding: 10px 16px;
  background: #fff;
  border-bottom: 1px solid #ebe9f1;
  font-weight: 600;
  font-size: 14px;
  color: #5e5873;
}

.poi-specific-card__body {
  padding: 16px 16px 4px;
}

.poi-specific-card__label {
  font-size: 13px;
  font-weight: 600;
  color: #6e6b7b;
  margin-bottom: 6px;
}
</style>
